import React, { useRef } from "react";

const LogoDownload = () => {
  const canvasRef = useRef(null);

  const downloadLogo = (variant) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const scale = 4;
    const width = 300;
    const height = 80;

    canvas.width = width * scale;
    canvas.height = height * scale;
    ctx.scale(scale, scale);

    // Transparent background for both versions
    ctx.clearRect(0, 0, width, height);

    const iconSvg = `
      <svg width="50" height="50" viewBox="-5 -5 160 130" xmlns="http://www.w3.org/2000/svg">
        <g fill="#2563EB">
          <path d="M57,36.1l-22.6,41.8c-0.3,0.5,0.1,1.2,0.7,1.2h47.8l19,34.6H29.8c-23.9,0-39.2-25.3-28.2-46.5l16.1-31H57z"/>
          <path d="M84.6,78.1l22.6-41.8c0.3-0.5-0.1-1.2-0.7-1.2H58.7l-19-34.6h72.1c23.9,0,39.2,25.3,28.2,46.5l-16.1,31H84.6z"/>
        </g>
      </svg>
    `;

    const img = new Image();
    const svgBlob = new Blob([iconSvg], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      ctx.drawImage(img, 2, 15, 50, 50);

      ctx.fillStyle = variant === "header" ? "#1e3a8a" : "#ffffff";
      ctx.font = "bold 32px Inter, sans-serif";
      ctx.letterSpacing = "-1px";
      ctx.fillText("Lloyd Funding", 55, 52);

      const link = document.createElement("a");
      link.download =
        variant === "header"
          ? "lloyd-funding-logo-header.png"
          : "lloyd-funding-logo-footer.png";
      link.href = canvas.toDataURL("image/png");
      link.click();

      URL.revokeObjectURL(url);
    };

    img.src = url;
  };

  return (
    <div className="min-h-screen bg-slate-100 py-12 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-2xl font-bold text-slate-800 mb-8">
          Download Logos
        </h1>

        {/* Header version preview */}
        <p className="text-sm font-medium text-slate-500 mb-2">
          Header Version (transparent background)
        </p>
        <div className="bg-white p-8 rounded-xl shadow-lg mb-4 inline-block">
          <div className="flex items-center gap-1">
            <svg
              style={{ height: "32px", width: "auto" }}
              viewBox="-5 -5 160 130"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#2563EB">
                <path d="M57,36.1l-22.6,41.8c-0.3,0.5,0.1,1.2,0.7,1.2h47.8l19,34.6H29.8c-23.9,0-39.2-25.3-28.2-46.5l16.1-31H57z" />
                <path d="M84.6,78.1l22.6-41.8c0.3-0.5-0.1-1.2-0.7-1.2H58.7l-19-34.6h72.1c23.9,0,39.2,25.3,28.2,46.5l-16.1,31H84.6z" />
              </g>
            </svg>
            <span className="text-2xl font-bold text-blue-900 tracking-tight leading-none">
              Lloyd Funding
            </span>
          </div>
        </div>
        <div className="mb-8">
          <button
            onClick={() => downloadLogo("header")}
            className="rounded-xl bg-blue-600 px-8 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 transition"
          >
            Download Header Logo
          </button>
        </div>

        {/* Footer version preview */}
        <p className="text-sm font-medium text-slate-500 mb-2">
          Footer Version (transparent background)
        </p>
        <div className="bg-slate-900 p-8 rounded-xl shadow-lg mb-4 inline-block">
          <div className="flex items-center gap-1">
            <svg
              style={{ height: "32px", width: "auto" }}
              viewBox="-5 -5 160 130"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#2563EB">
                <path d="M57,36.1l-22.6,41.8c-0.3,0.5,0.1,1.2,0.7,1.2h47.8l19,34.6H29.8c-23.9,0-39.2-25.3-28.2-46.5l16.1-31H57z" />
                <path d="M84.6,78.1l22.6-41.8c0.3-0.5-0.1-1.2-0.7-1.2H58.7l-19-34.6h72.1c23.9,0,39.2,25.3,28.2,46.5l-16.1,31H84.6z" />
              </g>
            </svg>
            <span className="text-2xl font-bold text-white tracking-tight leading-none">
              Lloyd Funding
            </span>
          </div>
        </div>
        <div className="mb-8">
          <button
            onClick={() => downloadLogo("footer")}
            className="rounded-xl bg-blue-600 px-8 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 transition"
          >
            Download Footer Logo
          </button>
        </div>

        <canvas ref={canvasRef} style={{ display: "none" }} />

        <p className="mt-4 text-sm text-slate-500">
          Both logos have transparent backgrounds.
          <br />
          Header: blue icon + navy text (#1e3a8a)
          <br />
          Footer: blue icon + white text
        </p>
      </div>
    </div>
  );
};

export default LogoDownload;
